import React, { useState, useEffect } from 'react';
import {
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Accordion,
  CircularProgress,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Table,
  ToggleButton,
  TableHead,
  TableBody,
  TableRow,
  TableCell
} from '@material-ui/core';
import ListIcon from '@material-ui/icons/List';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ToggleOnIcon from '@material-ui/icons/ToggleOn';
import ToggleOffIcon from '@material-ui/icons/ToggleOff';
import { baseUrl } from '../../utils/constants';
import TemplateModal from './TemplateModal';

const mockTemplateData = {
  templates: {
    mainAreas: {
      accessItems: [
        {
          key: 100010,
          value: 'Bridge',
          rightType: 1
        },
        {
          key: 100011,
          value: 'Bridge Admin',
          rightType: 0
        },
        {
          key: 100014,
          value: 'Europa Art Bridge',
          rightType: 1
        }
      ],
      replyStatus: 0,
      replyMessage: '',
      uniqueIdentifier: null,
      transactionRef: 0,
      otherRef: null,
      groupRef: null
    },
    bridgeAreas: {
      accessItems: [
        {
          key: 101101,
          value: 'Brd Match Employer',
          rightType: 1,
          replyStatus: 0,
          replyMessage: '',
          uniqueIdentifier: null,
          transactionRef: 0,
          otherRef: null,
          groupRef: null
        },
        {
          key: 101103,
          value: 'Brd Approve Validation',
          rightType: 0,
          replyStatus: 0,
          replyMessage: '',
          uniqueIdentifier: null,
          transactionRef: 0,
          otherRef: null,
          groupRef: null
        },
        {
          key: 101104,
          value: 'Brd Decline Validation',
          rightType: 0,
          replyStatus: 0,
          replyMessage: '',
          uniqueIdentifier: null,
          transactionRef: 0,
          otherRef: null,
          groupRef: null
        }
      ],
      replyStatus: 0,
      replyMessage: '',
      uniqueIdentifier: null,
      transactionRef: 0,
      otherRef: null,
      groupRef: null
    },
    searchAreas: {
      accessItems: [
        {
          key: 102101,
          value: 'Src Create New Action',
          rightType: 0,
          replyStatus: 0,
          replyMessage: '',
          uniqueIdentifier: null,
          transactionRef: 0,
          otherRef: null,
          groupRef: null
        },
        {
          key: 102102,
          value: 'Src Select Client Action',
          rightType: 0,
          replyStatus: 0,
          replyMessage: '',
          uniqueIdentifier: null,
          transactionRef: 0,
          otherRef: null,
          groupRef: null
        },
        {
          key: 102103,
          value: 'Src New Application Action',
          rightType: 0,
          replyStatus: 0,
          replyMessage: '',
          uniqueIdentifier: null,
          transactionRef: 0,
          otherRef: null,
          groupRef: null
        }
      ],
      replyStatus: 0,
      replyMessage: '',
      uniqueIdentifier: null,
      transactionRef: 0,
      otherRef: null,
      groupRef: null
    },

    clientDashboard: {
      accessItems: [
        {
          key: 109001,
          value: 'Clr Add Note',
          rightType: 0,
          replyStatus: 0,
          replyMessage: '',
          uniqueIdentifier: null,
          transactionRef: 0,
          otherRef: null,
          groupRef: null
        },
        {
          key: 109002,
          value: 'Clr Sms',
          rightType: 0,
          replyStatus: 0,
          replyMessage: '',
          uniqueIdentifier: null,
          transactionRef: 0,
          otherRef: null,
          groupRef: null
        },
        {
          key: 109003,
          value: 'Clr Over View O T P',
          rightType: 0,
          replyStatus: 0,
          replyMessage: '',
          uniqueIdentifier: null,
          transactionRef: 0,
          otherRef: null,
          groupRef: null
        }
      ],
      replyStatus: 0,
      replyMessage: '',
      uniqueIdentifier: null,
      transactionRef: 0,
      otherRef: null,
      groupRef: null
    },

    collections: {
      accessItems: [
        {
          key: 600001,
          value: 'Clet Management',
          rightType: 0,
          replyStatus: 0,
          replyMessage: '',
          uniqueIdentifier: null,
          transactionRef: 0,
          otherRef: null,
          groupRef: null
        },
        {
          key: 600003,
          value: 'Clet Collection Items Summary',
          rightType: 0,
          replyStatus: 0,
          replyMessage: '',
          uniqueIdentifier: null,
          transactionRef: 0,
          otherRef: null,
          groupRef: null
        },
        {
          key: 600004,
          value: 'Clet Flags',
          rightType: 0,
          replyStatus: 0,
          replyMessage: '',
          uniqueIdentifier: null,
          transactionRef: 0,
          otherRef: null,
          groupRef: null
        }
      ],
      replyStatus: 0,
      replyMessage: '',
      uniqueIdentifier: null,
      transactionRef: 0,
      otherRef: null,
      groupRef: null
    },

    cashManagement: {
      accessItems: [
        {
          key: 103100,
          value: 'C Mngt Teller',
          rightType: 0,
          replyStatus: 0,
          replyMessage: '',
          uniqueIdentifier: null,
          transactionRef: 0,
          otherRef: null,
          groupRef: null
        },
        {
          key: 103102,
          value: 'C Mngt Teller Disbursement',
          rightType: 0,
          replyStatus: 0,
          replyMessage: '',
          uniqueIdentifier: null,
          transactionRef: 0,
          otherRef: null,
          groupRef: null
        },
        {
          key: 103103,
          value: 'C Mngt Teller Receipt',
          rightType: 0,
          replyStatus: 0,
          replyMessage: '',
          uniqueIdentifier: null,
          transactionRef: 0,
          otherRef: null,
          groupRef: null
        }
      ],
      replyStatus: 0,
      replyMessage: '',
      uniqueIdentifier: null,
      transactionRef: 0,
      otherRef: null,
      groupRef: null
    },

    accounting: {
      accessItems: [
        {
          key: 104001,
          value: 'Acc Loan Recon',
          rightType: 0,
          replyStatus: 0,
          replyMessage: '',
          uniqueIdentifier: null,
          transactionRef: 0,
          otherRef: null,
          groupRef: null
        },
        {
          key: 104011,
          value: 'Acc Sundry Payments',
          rightType: 0,
          replyStatus: 0,
          replyMessage: '',
          uniqueIdentifier: null,
          transactionRef: 0,
          otherRef: null,
          groupRef: null
        },
        {
          key: 104021,
          value: 'Acc Pending Settlements',
          rightType: 0,
          replyStatus: 0,
          replyMessage: '',
          uniqueIdentifier: null,
          transactionRef: 0,
          otherRef: null,
          groupRef: null
        }
      ],
      replyStatus: 0,
      replyMessage: '',
      uniqueIdentifier: null,
      transactionRef: 0,
      otherRef: null,
      groupRef: null
    },

    bulkReceipting: { accessItems: [] },
    arrearsManagement: { accessItems: [] },
    brokers: { accessItems: [] },
    refunds: { accessItems: [] },
    report: { accessItems: [] },
    wallet: { accessItems: [] },
    settings: { accessItems: [] },
    tools: { accessItems: [] },
    banking: { accessItems: [] },
    workFlow: { accessItems: [] },
    apiController: { accessItems: [] }
  },
  replyStatus: 0,
  replyMessage: '',
  uniqueIdentifier: null,
  transactionRef: 0,
  otherRef: null,
  groupRef: null
};

const convertRightTypeToBoolean = (templateData) => {
  const updatedTemplate = JSON.parse(JSON.stringify(templateData));
  Object.values(updatedTemplate.templates).forEach((area) => {
    if (area.accessItems) {
      area.accessItems = area.accessItems.map((item) => ({
        ...item,
        rightType: Boolean(item.rightType)
      }));
    }
  });
  return updatedTemplate;
};

const convertBooleanToRightType = (templateDetails) => {
  const updatedDetails = JSON.parse(JSON.stringify(templateDetails));
  Object.values(updatedDetails.templates).forEach((area) => {
    if (area.accessItems) {
      area.accessItems = area.accessItems.map((item) => ({
        ...item,
        rightType: item.rightType ? 1 : 0
      }));
    }
  });
  return updatedDetails;
};

const ManageTemplates = () => {
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [templateDetails, setTemplateDetails] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  //   const fetchTemplates = async () => {
  //     try {
  //       const response = await fetch(`${baseUrl}/api/UserManagement/GetAccessTemplates`);
  //       const data = await response.json();
  //       setTemplates(data?.templates?.lookupList || []);
  //     } catch (error) {
  //       console.error('Failed to fetch templates:', error);
  //     }
  //   };

  const fetchTemplates = () => {
    const templates = [
      { id: 1, name: 'admin', description: 'Administrator with full access' },
      { id: 2, name: 'cashier', description: 'Cashier with transaction access' },
      { id: 3, name: 'technician', description: 'Technician with limited access' }
    ];
    setTemplates(templates);
  };

  const fetchTemplateDetails = async (templateId) => {
    setLoading(true);
    try {
      await new Promise((resolve) => setTimeout(resolve, 500));
      const convertedData = convertRightTypeToBoolean(mockTemplateData);
      setTemplateDetails(convertedData);
    } catch (error) {
      console.error('Failed to fetch template details:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  useEffect(() => {
    if (selectedTemplate) {
      fetchTemplateDetails(selectedTemplate);
    } else {
      setTemplateDetails(null);
    }
  }, [selectedTemplate]);

  const handleTemplateAdded = () => {
    fetchTemplates();
    setShowModal(false);
  };

  const areaMapping = {
    main: 'mainAreas',
    bridge: 'bridgeAreas',
    search: 'searchAreas',
    clientDashboard: 'clientDashboard',
    collections: 'collections',
    cashManagement: 'cashManagement',
    accounting: 'accounting',
    bulkReceipting: 'bulkReceipting',
    arrearsManagement: 'arrearsManagement',
    brokerManagement: 'brokers',
    refunds: 'refunds',
    reports: 'report',
    wallet: 'wallet',
    settings: 'settings',
    tools: 'tools',
    banking: 'banking',
    flowConfiguration: 'workFlow',
    apiControllers: 'apiController'
  };

  const permissionAreas = [
    { id: 'main', title: 'Main' },
    { id: 'bridge', title: 'Bridge' },
    { id: 'search', title: 'Search' },
    { id: 'clientDashboard', title: 'Client Dashboard' },
    { id: 'collections', title: 'Collections' },
    { id: 'cashManagement', title: 'Cash Management' },
    { id: 'accounting', title: 'Accounting' }
    // { id: 'bulkReceipting', title: 'Bulk Receipting' },
    // { id: 'arrearsManagement', title: 'Arrears Management' },
    // { id: 'brokerManagement', title: 'Broker Management' },
    // { id: 'refunds', title: 'Refunds' },
    // { id: 'reports', title: 'Reports' },
    // { id: 'wallet', title: 'Wallet' },
    // { id: 'settings', title: 'Settings' },
    // { id: 'tools', title: 'Tools' },
    // { id: 'banking', title: 'Banking' },
    // { id: 'flowConfiguration', title: 'Flow Configuration' },
    // { id: 'apiControllers', title: 'API Controllers' }
  ];

  const handleRightTypeChange = (areaKey, itemKey, newValue) => {
    setTemplateDetails((prevDetails) => ({
      ...prevDetails,
      templates: {
        ...prevDetails.templates,
        [areaKey]: {
          ...prevDetails.templates[areaKey],
          accessItems: prevDetails.templates[areaKey].accessItems.map((item) =>
            item.key === itemKey ? { ...item, rightType: newValue } : item
          )
        }
      }
    }));
  };

  const handleSave = async () => {
    if (!selectedTemplate || !templateDetails) return;

    try {
      setLoading(true);
      const payload = convertBooleanToRightType(templateDetails);

      const requestPayload = {
        ...payload,
        templateId: selectedTemplate
      };

      const response = await fetch(`${baseUrl}/api/UserManagement/UpdateTemplate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestPayload)
      });

      if (!response.ok) {
        throw new Error('Failed to update template');
      }

      const result = await response.json();
      console.log('Template updated successfully:', result);

      alert('Template updated successfully!');
    } catch (error) {
      console.error('Error updating template:', error);
      alert('Failed to update template. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="content px-xl-5 px-lg-4 px-3 py-3 page-body bg-card">
      <div className="d-flex justify-content-center mb-4">
        <div className="col-sm-12 col-md-6">
          <FormControl fullWidth>
            <InputLabel id="template-label">Template</InputLabel>
            <Select
              labelId="template-label"
              id="template-select"
              value={selectedTemplate}
              onChange={(e) => setSelectedTemplate(e.target.value)}
              label="Template"
              sx={{
                width: '250px',
                borderColor: 'success.main',
                color: 'success.main',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'success.main'
                }
              }}
            >
              <MenuItem value="">
                <em>-- Select Template --</em>
              </MenuItem>
              {templates.map((template) => (
                <MenuItem key={template.id} value={template.id}>
                  {template.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <div className="mt-2">
            <Button
              variant="text"
              color="inherit"
              size="small"
              startIcon={<ListIcon />}
              onClick={() => setShowModal(true)}
              sx={{ textTransform: 'none', p: 0 }}
            >
              Create New Template
            </Button>
          </div>
        </div>
      </div>

      <div className="card-body p-0">
        <div className="row g-4">
          <div className="col-12">
            {templateDetails ? (
              <div>
                {permissionAreas.map((area) => {
                  const jsonKey = areaMapping[area.id];
                  const areaData = templateDetails.templates[jsonKey];

                  return (
                    <Accordion key={area.id}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={`${area.id}-content`}
                        id={`${area.id}-header`}
                      >
                        <Typography>{area.title}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{ fontWeight: 'bold' }}>Function</TableCell>
                              <TableCell sx={{ fontWeight: 'bold' }}>Access Level</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {areaData?.accessItems?.length > 0 ? (
                              areaData.accessItems.map((item) => (
                                <TableRow key={item.key}>
                                  <TableCell>{item.value}</TableCell>
                                  <TableCell>
                                    <ToggleButton
                                      value="toggle"
                                      selected={item.rightType}
                                      onChange={() =>
                                        handleRightTypeChange(jsonKey, item.key, !item.rightType)
                                      }
                                      color="primary"
                                      size="small"
                                      sx={{
                                        padding: '4px 8px',
                                        textTransform: 'none',
                                        fontWeight: item.rightType ? 'bold' : 'normal'
                                      }}
                                    >
                                      {item.rightType ? (
                                        <ToggleOnIcon color="success" />
                                      ) : (
                                        <ToggleOffIcon color="disabled" />
                                      )}
                                    </ToggleButton>
                                  </TableCell>
                                </TableRow>
                              ))
                            ) : (
                              <TableRow>
                                <TableCell colSpan={2} align="center">
                                  No permissions defined
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </AccordionDetails>
                    </Accordion>
                  );
                })}
              </div>
            ) : (
              <div className="text-center my-5 py-4">
                <i className="bi bi-file-earmark-text display-6 text-muted" />
                <p className="mt-3">
                  {selectedTemplate
                    ? 'No template details available'
                    : 'Select a template to view permissions'}
                </p>
              </div>
            )}

            <div className="form-group form-actions mt-4">
              <div className="row">
                <div className="col-md-12 text-end">
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={loading}
                    onClick={handleSave}
                  >
                    {loading ? <CircularProgress size={24} /> : 'Save'}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <TemplateModal
        open={showModal}
        onClose={() => setShowModal(false)}
        onSuccess={handleTemplateAdded}
      />
    </div>
  );
};

export default ManageTemplates;
